import React, { Fragment } from "react";
import { Switch, Route } from "react-router";

import AdminDash from "./overview/Dashboard";
import Profile from "./profile";
import AddBuyer from "./buyer/AddBuyer";
import BuyerList from "./buyer/BuyerList";
import BuyerInner from "./buyer/BuyerInner";
import Transactions from "./buyer/Transaction";
import InvoiceInner from "./buyer/InvoiceInner";

import Comapny from "../views/company";
import AddContract from "./contract/AddContract";
import AddFabricContract from "./contract/AddFabricContract";
import EditFabricContract from "./contract/EditFabricContract";
import AddConversionContract from "./contract/AddConversionContract";
import EditConversionContract from "./contract/EditConversionContract";
import ContractList from "./contract/ContractList";
import YarnHistory from "./contract/YarnList";
import DispatchList from "./contract/DispatchList";
import DispatchInner from "./contract/DispatchInner";
import ContractInner from "./contract/ContractInner/index";
import SaveContract from "../PrintComponents/contract";
import DispatchInvoice from "../views/GenerateInvoice/dispatchInvoice";
import InvoicePreview from "../views/GenerateInvoice/InvoicePreview";

import General from "./settings";
import AddSizer from "./sizer/AddSizer";
import SizerList from "./sizer/SizerList";
import SendYarn from "./sizer/SendYarn";
import AddProgram from "./sizer/AddProgram";
import SizerIner from "./sizer/SizerInner/index";
import SizingProgram from "./sizer/SizingProgram";
import PaymentHistory from "./sizer/PaymentHistory";
import SizerRates from "./sizer/SizerRates";
import YarnInStock from "./sizer/YarnInStock";
import YarnStockHistory from "./sizer/YarnStockHistory";
import SizerMain from "./sizer/SizerMain";
import ProgramDetail from "./sizer/ProgramDetail";
import ProgramHistoryCompo from "./sizer/ProgramHistory";
import ClothReturnHistory from "../views/contract/ClothReturnHistory";
import SaleRegister from "./contract/SaleRegister";
import PreviewReport from "./GenerateInvoice/PreviewReport";
import PrintInvoice from "./GenerateInvoice/PrintInvoice";

import GenerateBill from "./sizer/GenerateBill";
import SizerInvoice from "./sizer/SizerInvoice";
const My404Component = () => {
  return <h3>404 - Not found</h3>;
};

const Admin = () => {
  return (
    <Fragment>
      <Switch>
        <Route exact path={`/`}>
          <Comapny />
        </Route>
        <Route exact path={`/profile`}>
          <Profile />
        </Route>
        <Route exact path={`/admin`}>
          <AdminDash />
        </Route>
        <Route path={`/addBuyer`}>
          <AddBuyer />
        </Route>
        <Route path={`/buyer-list`}>
          <BuyerList />
        </Route>
        <Route path={`/buyer-inner`}>
          <BuyerInner />
        </Route>
        <Route path={`/transactions`}>
          <Transactions />
        </Route>
        <Route path={`/invoice-inner/:invoiceId`}>
          <InvoiceInner />
        </Route>
        <Route path={`/invoice-inner`}>
          <InvoiceInner />
        </Route>
        <Route path="/print/contract">
          <SaveContract />
        </Route>
        <Route path="/print-invoice/:id">
          <PrintInvoice />
        </Route>
        {/* COntract Routes */}
        <Route path={`/add-contract`}>
          <AddContract />
        </Route>
        <Route path={`/fabric-contract`}>
          <AddFabricContract />
        </Route>
        <Route path={`/edit/fabric-contract/:id`}>
          <EditFabricContract />
        </Route>
        <Route path={`/conversion-contract`}>
          <AddConversionContract />
        </Route>
        <Route path={`/edit/conversion-contract/:id`}>
          <EditConversionContract />
        </Route>
        <Route path={`/contract-list`}>
          <ContractList />
        </Route>
        <Route path={`/yarn-history`}>
          <YarnHistory />
        </Route>
        <Route path={`/dispatch-list`}>
          <DispatchList />
        </Route>
        <Route path={`/dispatch-inner`}>
          <DispatchInner />
        </Route>
        <Route path={`/contract-inner/:contractNo`}>
          <ContractInner />
        </Route>
        <Route path={`/generate-invoice`}>
          <DispatchInvoice />
        </Route>
        <Route exact path={`/invoice-preview`}>
          <InvoicePreview />
        </Route>
        <Route path={`/sale-register`}>
          <SaleRegister />
        </Route>
        <Route path={`/preview-report`}>
          <PreviewReport />
        </Route>

        <Route path={`/return-history`}>
          <ClothReturnHistory />
        </Route>

        {/* Setting Route */}

        <Route path={`/general`}>
          <General />
        </Route>
        <Route path={`/add-user`}>
          <General />
        </Route>
        <Route path={`/manage-roles`}>
          <General />
        </Route>
        <Route path={`/add-yarn-quality`}>
          <General />
        </Route>
        <Route path={`/add-cloth-quality`}>
          <General />
        </Route>
        <Route path={`/add-tax-rate`}>
          <General />
        </Route>

        <Route path={`/add-weave`}>
          <General />
        </Route>

        <Route path={`/add-selvedge`}>
          <General />
        </Route>

        <Route path={`/add-hs_code`}>
          <General />
        </Route>

        {/* Sizer Route */}

        <Route path={`/add-sizer`}>
          <AddSizer />
        </Route>
        <Route path={`/sizer-list`}>
          <SizerList />
        </Route>
        <Route path={`/send-yarn`}>
          <SendYarn />
        </Route>
        <Route path={`/add-program`}>
          <AddProgram />
        </Route>
        <Route path={`/sizer-inner/:id`}>
          <SizerIner />
        </Route>
        <Route path={`/sizing-program`}>
          <SizingProgram />
        </Route>
        <Route path={`/sizer-payment-history`}>
          <PaymentHistory />
        </Route>
        <Route path={`/sizer/:id/sizer-rates`}>
          <SizerRates />
        </Route>
        <Route path={`/yarn-stock`}>
          <YarnInStock />
        </Route>
        <Route path={`/yarn-stock-history`}>
          <YarnStockHistory />
        </Route>
        <Route path={`/sizer-dashboard`}>
          <SizerMain />
        </Route>
        <Route path="/program-details/:programId">
          <ProgramDetail />
        </Route>
        <Route path="/program-details">
          <ProgramDetail />
        </Route>
        <Route path={`/program-history`}>
          <ProgramHistoryCompo />
        </Route>
        <Route path="/pay-now">
          <GenerateBill />
        </Route>
        <Route path="/generate-bill/:id">
          <SizerInvoice />
        </Route>
        <Route path="*" exact={true} component={My404Component} />
      </Switch>
    </Fragment>
  );
};

export default Admin;
